import ArticleIcon from "@mui/icons-material/Article";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { IdentificationDocumentsDialog } from "./IdentificationDocumentsDialog";

export const IdentificationDocumentsButton = (props) => {
    const { personId, disabled = false, showLabel = true, variant = "text" } = props;
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();

    const handleOpenDialog = () => {
        openDialog({
            Component: IdentificationDocumentsDialog,
            componentProps: {
                personId: personId,
            },
        });
    };

    return (
        <Button
            onClick={handleOpenDialog}
            disabled={disabled}
            variant={variant}
            fullWidth
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
                py: 1.5,
                minHeight: showLabel ? 80 : "auto",
            }}
        >
            <ArticleIcon sx={{ fontSize: showLabel ? 32 : 24 }} />
            {showLabel && (
                <Typography variant="caption" sx={{ textTransform: "none", lineHeight: 1.2 }}>
                    {t("clients.IdentificationDocumentsDialog.buttonLabel")}
                </Typography>
            )}
        </Button>
    );
};
